const Styles = {
    'RadioInput': 'RadioInput_RadioInput--372d9f4e'
};

export default Styles;